export default __webpack_public_path__ + "static/media/contact.efa37db5.svg";